import axios from 'axios';
import * as env from '@/config/env';
import {isLocalMode, refreshLocalSession} from '@/utils/localSession';
// Local development uses the dev-server /api proxy. Keeping requests
// same-origin avoids browser privacy extensions blocking localhost:4000.
const apiHost = process.env.VUE_APP_LOCAL_MODE === 'true' ? '' : process.env.VUE_APP_APIURL;
export const axiosInstance = axios.create({ baseURL: apiHost });
export const axiosInstanceWithFormData = axios.create({ baseURL: apiHost });
export const axiosInstanceWithoutCompany = axios.create({ baseURL: apiHost });
export const axiosInstanceWithoutCompanyWithFormData = axios.create({ baseURL: apiHost });



axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem('token') || "";
    const companyId = localStorage.getItem('selectedCompany') || "";
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'companyId': companyId
    }
    req.headers = headers;
    return req;
}, error => {
    return Promise.reject(error);
});

axiosInstanceWithFormData.interceptors.request.use((req) => {
    const token = localStorage.getItem('token') || "";
    const companyId = localStorage.getItem('selectedCompany') || "";
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token,
        'companyId': companyId
    }
    req.headers = headers;
    return req;
}, error => {
    return Promise.reject(error);
});

axiosInstanceWithoutCompany.interceptors.request.use((req) => {
    const token = localStorage.getItem('token') || "";
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
    req.headers = headers;
    return req;
}, error => {
    return Promise.reject(error);
});

axiosInstanceWithoutCompanyWithFormData.interceptors.request.use((req) => {
    const token = localStorage.getItem('token') || "";
    const companyId = localStorage.getItem('selectedCompany') || "";
    const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': 'Bearer ' + token,
        ...(companyId ? {'companyId': companyId} : {})
    }
    req.headers = headers;
    return req;
}, error => {
    return Promise.reject(error);
});




export const getAuth = async (id,isFirst) => {
    if (isLocalMode()) {
        const token = await refreshLocalSession();
        return {status: true, token};
    }
    return new Promise((resolve, reject) => {
        let data = {
            uid: id
        };
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + (localStorage.getItem('token') || '')
        };
        let url = env.GENERATETOKEN;
        axios.post(apiHost + url, data, { headers }).then((result) => {
            localStorage.setItem('token', result.data.token)
            if (isFirst) {
                localStorage.setItem('updateToken', result.data.token)
            }
            resolve(result.data);
        }).catch((error) => {
            const detail = error?.response?.data || error;
            console.error('error', detail);
            reject(detail);
        });
    })
};

export const apiRequest = (type, endPoint, data, dataType, retryCount = 0) => {
    return new Promise((resolve, reject) => {
        try {
            if (type === 'post' || type === 'patch' || type === 'get' || type === 'put' || type === 'delete') {
                let rData;
                if (dataType === 'form') {
                    rData = axiosInstanceWithFormData[type](endPoint, data);
                } else if (dataType === 'blob') {
                    rData = axiosInstance[type](endPoint, data, {responseType: 'blob'});
                } else {
                    rData =  axiosInstance[type](endPoint, data);
                }

                rData
                    .then((resData) => {
                        resolve(resData);
                    })
                    .catch(async (err) => {
                    if (err?.response?.data?.isJwtError && retryCount < 1) {
                        const userId = localStorage.getItem('userId') || "";
                        try {
                            await getAuth(userId);
                            apiRequest(type, endPoint, data, dataType, retryCount + 1).then(resolve).catch(reject);
                        } catch (refreshError) { reject(refreshError); }
                        return;
                    }
                    reject(err);
                });
            } else {
                console.info(type)
            }
        } catch (error) {
            console.error('error', error);
            reject(error);
        }
    })
}


export const apiRequestWithoutCompnay = (type, endPoint, data, dataType, retryCount = 0) => {
    return new Promise((resolve, reject) => {
        try {
            if (type === 'post' || type === 'patch' || type === 'get') {
                let rData;
                if (dataType === 'form') {
                    rData = axiosInstanceWithoutCompanyWithFormData[type](endPoint, data);
                } else {
                    rData = axiosInstanceWithoutCompany[type](endPoint, data);
                }
                rData
                    .then((resData) => {
                        resolve(resData);
                    })
                    .catch(async (err) => {
                    if (err?.response?.data?.isJwtError && retryCount < 1) {
                        const userId = localStorage.getItem('userId') || "";
                        try {
                            await getAuth(userId);
                            apiRequestWithoutCompnay(type, endPoint, data, dataType, retryCount + 1).then(resolve).catch(reject);
                        } catch (refreshError) { reject(refreshError); }
                        return;
                    }
                    reject(err);
                });
            } else {
                console.info(type)
            }
        } catch (error) {
            console.error('error', error);
            reject(error);
        }
    })
}
